import type * as React from 'react'
import { clsx } from 'clsx'

import styles from './SavingsHint.module.css'

interface SavingsHintProps {
  children: React.ReactNode
  visible: boolean
  className?: string
  style?: React.CSSProperties
}

/**
 * A simple positioned savings hint that looks like a hover card
 * but avoids the complexity of actual overlay components.
 */
export const SavingsHint: React.FC<SavingsHintProps> = ({
  children,
  visible,
  className,
  style,
}) => {
  if (!visible) return null

  return (
    <div className={clsx(styles.savingsHint, className)} style={style}>
      {children}
      <div className={styles.arrow} />
    </div>
  )
}
